import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import EnotesSubjectTable from './EnotesSubjectTable';
const EnotesSubject = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Enotes Subject' parent='Enotes Subject'  />
      <Container fluid={true}>
        <Row>
          <EnotesSubjectTable  />
        </Row>
      </Container>
    </Fragment>
  );
};

export default EnotesSubject;
